module.exports = __webpack_public_path__ + "img/hero-image-compra-mobile.3bff0b2a.png";